/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Group from 'material/group/group';
import SearchBar from 'material/searchbar/searchbar';
import DropDownItem from 'material/dropdowns/searchabledropdown/dropdownitem/dropdownitem';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/dropdowns/searchabledropdown/searchabledropdown_styles';



/* ========== ~~~~~~~~~~ DROP FILTER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
    class SearchableDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            selected: '',
            searchTerm: '',
            items: this.props.items
        };
    }

    componentDidMount() {
        return document.addEventListener('mousedown', this.handleOutsideClick, false);
    }

    componentWillUnmount() {
        return document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }

    componentDidUpdate(prevProps){
        if(prevProps.items.length !== this.props.items.length){
            this.setState({items: this.props.items})
        }
    }

    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node.contains(e.target)) { return; }
        this.hideMenu();
    };

    showMenu = () => this.setState({ active: true });
    hideMenu = () => this.setState({ active: false, searchTerm: '',items: this.props.items});

    handleClick=()=> this.state.active ? this.hideMenu() : this.showMenu();

    renderItems = ()=>{
        return  this.state.items.map((item, i)=>{
            return <DropDownItem handleSelect={this.handleSelect} searchTerm={this.state.searchTerm} name={item.name} value={item.value} itemSelected={this.state.items[i].value === item.value} key={i} index={i} item={item}  />
        })
    };

    handleSelect = item =>{
        this.setState({selected: item.name, active: false, searchTerm: '', items: this.props.items});
        this.props.handleSelect(item)
    };

    handleSearch = (keywords)=>{

        let initialItems = this.props.items.map(item=>item.name.toLowerCase());
        let filteredItems = initialItems.filter(item=>item.indexOf(keywords.toLowerCase()) >= 0);
        let items = this.props.items.filter(item=>filteredItems.indexOf(item.name) >= 0);


        // let filteredItems = this.props.items.filter(item=>item.indexOf(keywords) >=0); // !!!! this should be case insensitive
        this.setState({items: items, searchTerm:keywords});
    };


    render() {
        let {name} = this.props;
        let { active } = this.state;
        return (
            <div className={`searchabledropdown ${this.props.classes.searchabledropdown} disabled-${this.props.disabled}`} ref={node => {this.node=node;}}>
                <div className={`placeholder active-${active}`} onClick={this.handleClick}><span>{this.props.selected ? this.props.selected.name : this.props.name}</span><Icon name={`sort-down`}/></div>
                <Group name={`menuItems active-${active}`}  >
                    <SearchBar value={this.state.searchTerm} placeholder={name} onChange={this.handleSearch} />
                    <Group name={`items`}>
                            {this.renderItems()}
                    </Group>
                </Group>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SearchableDropDown);